import { useState } from 'react';
import automobyApi from '../Api';

export const useTitle = () => {
  const [items, setItems] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const fetch = async () => {
    try {
      setIsLoading(true);
      const response = await automobyApi.post('/title/list');
      setItems(response.data.titles || []);
    } catch (error) {
      console.error('Failed to load titles', error);
    } finally {
      setIsLoading(false);
    }
  };

  const add = async (payload) => {
    try {
      await automobyApi.post('/title/create', payload);
      await fetch();
    } catch (error) {
      console.error('Failed to create title', error);
      throw error;
    }
  };

  const update = async (payload) => {
    try {
      await automobyApi.post('/title/update', payload);
      await fetch();
    } catch (error) {
      console.error('Failed to update title', error);
      throw error;
    }
  };

  const remove = async (id) => {
    try {
      await automobyApi.post('/title/delete', { title_id: id });
      await fetch();
    } catch (error) {
      console.error('Failed to delete title', error);
      throw error;
    }
  };

  const titleService = {
    items,
    isLoading,
    fetch,
    add,
    update,
    remove,
  };

  return { titleService };
};
